<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import MoreInfoIcon from '@/components/icons/MoreInfoIcon.vue';
import CloseIcon from '@/components/icons/CloseIcon.vue';

const props = defineProps({
  contents: {
    type: Object,
    default: null,
  },
});

const benefit = computed(() => props.contents?.tooltip || '');
const details = computed(() => props.contents?.description || '');
const hasContent = computed(() => !!props.contents?.tooltip && !!props.contents?.description);
</script>

<template>
  <Popover v-if="hasContent">
    <div class="bg-br-green-light px-4 py-3 flex flex-col gap-2 relative bottom-full">
      <div class="flex items-center justify-between">
        <p class="font-bold text-sm leading-relaxed md:text-md">
          {{ benefit }}
        </p>
        <PopoverButton class="flex items-center text-xs lg:text-base font-normal underline p-1 whitespace-nowrap">
          <span class="mr-1">{{ $t('tooltip.moreInfo') }}</span>
          <MoreInfoIcon class="text-black" />
        </PopoverButton>
      </div>
    </div>

    <div>
      <PopoverPanel
        v-slot="{ close }"
        :unmount="false"
        class="absolute bottom-11 bg-white text-black text-sm p-4 shadow-lg inset-x-2 z-10 after:content-[''] after:absolute after:-bottom-2 after:right-[.875rem] after:w-0 after:h-0 after:border-l-8 after:border-r-8 after:border-t-8 after:border-l-transparent after:border-r-transparent after:border-t-white"
      >
        <button class="absolute top-0 right-0 p-3" @click.stop="close()" :aria-label="$t('tooltip.close')">
          <CloseIcon class="h-5 text-blackly hover:text-br-green" />
        </button>
        <div class="text-copy pr-4" v-html="details"></div>
      </PopoverPanel>
    </div>
  </Popover>
</template>
